import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpClient } from "@angular/common/http";
import { ToastController, AlertController } from "ionic-angular";
import { ENV } from '@app/env';

@Injectable()
export class ErrorService {
  apiUrl = ENV.apiUrl;

  constructor(
    private http: HttpClient,
    private toastController: ToastController,
    private alertController: AlertController
  ) { }

  handleError(error) {
    // let message = "";
    // if (error.error) {
    //   if (error instanceof HttpErrorResponse) {
    //     if (error.error.error) {
    //       message += error.error.error;
    //     } else {
    //       message += error.error.errorMessage ? error.error.errorMessage : error.error;
    //     }
    //   } else {
    //     message += error.error.errorMessage ? error.error.errorMessage : error.error;
    //   }
    // } else {
    //   message += error;
    // }
    console.error(error);
    // this.toastController
    //   .create({
    //     message: "Oeps er ging iets fout. " + message,
    //     duration: 6000,
    //     buttons: [
    //       {
    //         text: "Ok",
    //       },
    //     ],
    //   })
    //   .then((toast) => {
    //     toast.present();
    //   });
    return error;
  }

  sendErrorReport(error, json) {
    // this.alertController
    //   .create({
    //     title: "Er ging iets fout",
    //     message: "Wilt u een foutmelding versturen?",
    //     buttons: [
    //       {
    //         text: "Nee",
    //         role: "cancel",
    //         cssClass: "secondary",
    //       },
    //       {
    //         text: "Ja",
    //         handler: () => {
    //           const sendJson = {
    //             error: JSON.stringify(error),
    //             json: json ? JSON.stringify(json) : null,
    //           };
    //           this.http
    //             .post(`${this.apiUrl}error/`, JSON.stringify(sendJson))
    //             .subscribe(() => {
    //               this.toastController
    //                 .create({
    //                   message: "Foutmelding verstuurd",
    //                   duration: 6000,
    //                   buttons: [
    //                     {
    //                       text: "Ok",
    //                     },
    //                   ],
    //                 })
    //                 .then((toast) => {
    //                   toast.present();
    //                 });
    //             });
    //         },
    //       },
    //     ],
    //   })
    //   .then((alert) => {
    //     alert.present();
    //   });
  }
}



// WEBPACK FOOTER //
// ./src/providers/error/error.service.ts